export default "__VITE_ASSET__Bhutc9Zk__"